import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.5688 10.2357L11.0974 9.76425L7.99981 12.8619L4.90218 9.76425L4.43078 10.2357L7.99981 13.8047L11.5688 10.2357Z",
      fill: "#8E8E93"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.5688 5.76435L11.0974 6.23575L7.99981 3.13812L4.90218 6.23575L4.43078 5.76435L7.99981 2.19531L11.5688 5.76435Z",
      fill: "#8E8E93"
    }, null, -1)
  ])))
}
export default { render: render }